
import OPicture from "@/components/base/image/OPicture"
import JobGallery from "@/components/job/jobpage/JobGalleryV3"
import { mdiOpenInNew } from "@mdi/js"

export default {
    name: "Article",
    components: {
        JobGallery,
        OPicture,
        Tag: () => import("@/components/base/Tag"),
        ArticleHostCard: () =>
            import("@/components/article/page/ArticleHostCard"),
        ArticleDateTime: () =>
            import("@/components/article/page/ArticleDateTime"),
    },
    icons: { mdiOpenInNew },
    props: {
        article: {
            type: Object,
            required: true,
        },
    },
    computed: {
        anyDates() {
            return !!this.article.start_at || !!this.article.end_at
        },
        eventAddressText(article) {
            const eventAddress = article.event_address
            if (!eventAddress) {
                return ""
            }
            return `${eventAddress.street}, ${eventAddress.postal_code} ${eventAddress.city}`
        },
    },
    methods: {
        onShowMore(block, medium) {
            if (block.length === 0) {
                block = { media: [medium] }
            }
            this.$fullscreenMedia.open(block.media, { initialId: medium.id })
        },
    },
}
